import { ClubLocalModule } from '@modules/application/application';

export const AccountSettingsLocalModule: ClubLocalModule = {
    code: '93aae2968df995f78e23eefab4b48ff2',
    url: 'account-settings',
    localEnabled: true,
    icon: 'user',
};
